import { LESS_984_MEDIA_QUERY, LESS_512_MEDIA_QUERY } from '../../../../consts/adaptive';

const font = {
    fontFamily: 'Open Sans, Arial, sans-serif',
    fontStyle: 'normal',
    fontWeight: 400,
};

const weightFont = {
    fontFamily: 'Open Sans, Arial, sans-serif',
    fontStyle: 'normal',
    fontWeight: 700,
};

const tag = {
    marginTop: 0,
    marginBottom: 17,
    fontSize: '14px',
    lineHeight: '150%',
    ...font,
};

const grayLine = '2px solid #f6f6f6';
const rightSideWidth = 220;

export const styles = {
    container: {
        width: '100%',
        height: 'fit-content',
        marginBottom: 15,
        padding: 20,
        background: '#F6F6F6',
        borderRadius: '8px',
        boxSizing: 'border-box',
    },
    content: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    withManagementResponse: {
        paddingLeft: 16,
        position: 'relative',

        '&:before': {
            content: '""',
            position: 'absolute',
            left: 0,
            bottom: 0,
            display: 'block',
            width: 28,
            height: 'calc(100% - 16px)', // 16px- это половина от высоты кружка рейтинга
            background: 'transparent',
            borderLeft: '2px solid #e7e7e7',
            borderTop: '2px solid #e7e7e7',
            borderRadius: '8px 0 0 0',
            zIndex: 1,
        }
    },
    leftContent: {
        minWidth: '70%',
        paddingRight: 10,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
    },
    rightContent: {
        width: rightSideWidth,
        marginLeft: 10,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        flexShrink: 0,
    },
    shortTourInfo: {
        display: 'flex',
        flexDirection: 'column',
    },
    tripDate: {
        color: '#9B9B9B',
        ...tag,
    },
    sourceLogo: {
        height: 30,
        width: 120,
        marginTop: 24,
        marginBottom: 15,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
    },
    reporter: {
        marginBottom: 17,
        display: 'flex',
        alignItems: 'center',
    },
    reporterName: {
        fontSize: '14px',
        maxWidth: '18ch',
        ...weightFont,
    },
    tag: {
        color: 'black',
        ...tag,
    },
    reviewCreated: {
        color: '#9B9B9B',
        ...tag,
    },
    infoBlockTablet: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
    },
    sourceLogoReviewCreatedWrap: {
        position: 'relative',
        width: '100%',
        marginBottom: 5,
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'row-reverse',
        borderLeft: grayLine,
    },
    tagWrapper: {
        position: 'relative',
        borderLeft: grayLine,
    },
    [LESS_984_MEDIA_QUERY]: {
        container: {
            width: 'auto',
        },
        leftContent: {
            paddingRight: 0,
        },
        rightContent: {
            display: 'none',
        },
        reporter: {
            marginBottom: 4,
        },
        sourceLogo: {
            width: 108,
            marginTop: 0,
            marginBottom: 4,
        },
        reporterName: {
            fontSize: '12px',
        },
        tag: {
            fontSize: '10px',
            marginBottom: 0,

            ['&:first-child:not(:only-child)']: {
                marginBottom: 12,
            },
        },
        tripDate: {
            fontSize: '10px',
            marginBottom: 0,
        },
        reviewCreated: {
            fontSize: '10px',
            marginBottom: 0,
        },
    },
    [LESS_512_MEDIA_QUERY]: {
        reviewCreated: {
            padding: [13, 0],
        },
        reporterName: {
            fontSize: '10px',
        },
        tripDate: {
            fontSize: '8px',
        },
    },
};

export type ComponentJSSClasses = JSSClasses<typeof styles>;
